import { trackEvent } from '../utils/event-tracker';
import {
  LOCAL_FOCUS_CITY_INSIGHTS_GENERATION_TRIGGERED,
  LOCAL_FOCUS_NEIGHBOURHOOD_IMAGE_GENERATION_TRIGGERED,
  LOCAL_FOCUS_HERO_IMAGE_GENERATION_TRIGGERED,
  LOCAL_FOCUS_CONTENT_TYPE,
} from '../constants/local-focus-generation-events';

export interface CityInsightsGenerationTriggeredParams {
  slug: string;
  city: string;
  province: string;
  country: string;
  tenantId?: string;
}

export interface NeighbourhoodImageGenerationTriggeredParams {
  slug: string;
  neighbourhood: string;
  city: string;
  tenantId?: string;
}

export interface HeroImageGenerationTriggeredParams {
  slug: string;
  city: string;
  country: 'CA' | 'US';
  tenantId?: string;
}

export const LocalFocusGenerationObservabilityService = {
  /** Track that City Insights generation was requested for a missing city. */
  trackCityInsightsGenerationTriggered(params: CityInsightsGenerationTriggeredParams): void {
    const { slug, city, province, country, tenantId } = params;

    trackEvent(
      LOCAL_FOCUS_CITY_INSIGHTS_GENERATION_TRIGGERED,
      {
        contentType: LOCAL_FOCUS_CONTENT_TYPE.CITY_INSIGHTS,
        slug,
        city,
        province,
        country,
      },
      tenantId
    );
  },

  /** Track that a neighbourhood image generation was requested for a missing image. */
  trackNeighbourhoodImageGenerationTriggered(params: NeighbourhoodImageGenerationTriggeredParams): void {
    const { slug, neighbourhood, city, tenantId } = params;

    trackEvent(
      LOCAL_FOCUS_NEIGHBOURHOOD_IMAGE_GENERATION_TRIGGERED,
      {
        contentType: LOCAL_FOCUS_CONTENT_TYPE.NEIGHBOURHOOD_IMAGE,
        slug,
        neighbourhood,
        city,
      },
      tenantId
    );
  },

  /** Track that a hero image generation was requested for a missing city hero. */
  trackHeroImageGenerationTriggered(params: HeroImageGenerationTriggeredParams): void {
    const { slug, city, country, tenantId } = params;

    trackEvent(
      LOCAL_FOCUS_HERO_IMAGE_GENERATION_TRIGGERED,
      {
        contentType: LOCAL_FOCUS_CONTENT_TYPE.HERO_IMAGE,
        slug,
        city,
        country,
      },
      tenantId
    );
  },
} as const;
